module.exports = __webpack_public_path__ + "img/widget-1.fb3ba02a.png";